import React from "react";
import ReactDOM from "react-dom/client";
import BaziCalculator from "./BaziCalculator";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BaziCalculator />
  </React.StrictMode>
);
